module.exports = __webpack_public_path__ + "static/media/register-image.1a84fcd0.jpg";